import request from '@/utils/request'
import requestOlsera from '@/utils/requestOlsera'
import requestCollection from '@/utils/requestCollection'
import store from '@/store'

const endpoint = '/api/admin/v1/'
const endpointCollection = 'api/open-api/v1/'

export function loginOlsera (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/login_olsera',
    method: 'POST',
    data
  }
  return request(opt)
}

export function user (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/me',
    method: 'GET',
    params: data
  }
  return request(opt)
}

export function pairingStore (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/register_olsera',
    method: 'POST',
    data
  }
  return requestOlsera(opt)
}

export function listStore (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/store_user',
    method: 'GET',
    params: data
  }
  return requestOlsera(opt)
}

export function storeDetail (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/store_user',
    method: 'GET',
    params: data
  }
  return requestOlsera(opt)
}

export function listPairingStore (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/register_olsera',
    method: 'GET',
    params: data
  }
  return requestOlsera(opt)
}

export function detailPairingStore (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/register_olsera/' + data.id,
    method: 'GET',
    params: data
  }
  return requestOlsera(opt)
}

export function updatePairingStore (id, data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/update_olsera/' + id,
    method: 'POST',
    data
  }
  return requestOlsera(opt)
}

export function updateSecret (id) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/new-secret-key/' + id,
    method: 'POST'
  }
  return requestOlsera(opt)
}

export function categoryApp (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/category',
    method: 'GET',
    params: data
  }
  return requestOlsera(opt)
}

export function tagsApp (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/all-taqs',
    method: 'GET',
    params: data
  }
  return requestOlsera(opt)
}

export function revokeApp (data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/revoke_olsera/' + data.id,
    method: 'DELETE'
  }
  return requestOlsera(opt)
}

export function sendCollection (data) {
  let opt = {}
  const headers = {
    Authorization: 'Bearer ' + data.accesToken
  }
  if (data.method === 'GET') {
    opt = {
      headers,
      url: data.endpoint,
      method: data.method,
      params: data.params
    }
  } else {
    opt = {
      headers,
      url: data.endpoint,
      method: data.method,
      data: data.params
    }
  }
  return requestCollection(opt)
}

export function sendCollectionToken (data) {
  const opt = {
    url: data.endpoint,
    method: data.method,
    data: data.params
  }
  return requestCollection(opt)
}

export function sendCollectionWebhook (data, request_header) {
  const headers = {
    request_header
  }
  const opt = {
    headers,
    url: data.endpoint,
    method: data.method,
    data: data
  }
  return requestCollection(opt)
}

export function tokenCollection (params) {
  const data = {
    app_id: params.app_id,
    secret_key: params.secret_key,
    grant_type: 'secret_key'
  }
  const opt = {
    url: endpointCollection + store.getters['app/lang'] + '/token',
    method: 'POST',
    data
  }
  return requestCollection(opt)
}

export function webhookSave (id, data) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/webhook/save/' + id,
    method: 'POST',
    data
  }
  return requestOlsera(opt)
}

export function webhookCheckUrl (id) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/webhook/check-url/' + id,
    method: 'GET'
  }
  return requestOlsera(opt)
}

export function webhookLog (id, params) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/webhook/log/' + id,
    method: 'GET',
    params
  }
  return requestOlsera(opt)
}

export function webhookHistory (id, params) {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/webhook/history/' + id,
    method: 'GET',
    params
  }
  return requestOlsera(opt)
}

export function logoutOlsera () {
  const opt = {
    url: endpoint + store.getters['app/lang'] + '/logout_olsera',
    method: 'POST'
  }
  return requestOlsera(opt)
}
